import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrGetTermPathParameters } from 'api/actions/hr-get-term/hr-get-term-path-parameters';
import { HrGetTermResponse } from 'api/actions/hr-get-term/hr-get-term-response';

type HrGetTermQueryParameters = Record<string, any>;

/**
 * The path of the HrGetTerm action.
 */
export const hrGetTermActionPath = new SweetPath<keyof HrGetTermPathParameters>('/api/hr/terms/{termId}', {
  path: '{param}',
});

/**
 * Creates a contextualized HrGetTerm actions.
 */
export default function createHrGetTermAction(axios: AxiosInstance) {
  return function hrGetTermAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrGetTermPathParameters;
    query?: HrGetTermQueryParameters;
  }) {
    const path = hrGetTermActionPath.insert(parameters);

    return axios.request<HrGetTermResponse, HrGetTermResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
